import { NgModule } from '@angular/core';

import { CashFlowContainerComponent } from './cash-flow.container';

import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { CashFlowEffects } from './cash-flow.effects';
import { SharedModule } from '../../shared/shared.module';
import { PipesModule } from '../../global/pipes/pipes.module';
import { FieldModule } from 'atlas-field';
import { IconModule } from 'atlas-icon';
import { LegacyModule } from 'atlas-legacy';
import { TableModule } from 'atlas-table';
import { CdkModule } from 'atlas-cdk';
import { TooltipModule } from 'atlas-tooltip';
import { MenuModule } from 'atlas-menu';
import { ListModule } from 'atlas-list';
import { LinkModule } from 'atlas-link';
export const COMPONENTS = [
  CashFlowContainerComponent
];

@NgModule({
  declarations: COMPONENTS,
  imports: [
    // MercerOSModule,
    FormsModule,
    CommonModule,
    SharedModule,
    PipesModule,
    FieldModule,
    IconModule,
    LegacyModule,
    TableModule,
    CdkModule,
    TooltipModule,
    MenuModule,
    ListModule,
    LinkModule,
    EffectsModule.forFeature([CashFlowEffects])
  ],
  exports: COMPONENTS,
  providers: [],
  bootstrap: [],
})
export class CashFlowModule {
}
